import React from 'react';
import './options.css';

function Options({children, method}) {
    return (
        <div className="options-area" onClick={method}>
            {children}
        </div>
    );
}

export default Options;